import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface KpiCardProps {
    title: string;
    value: string | number;
    icon: React.ReactNode;
    color: string;
    linkTo?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({ title, value, icon, color, linkTo }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (linkTo) {
            navigate(linkTo);
        }
    };

    return (
        <Card
            sx={{
                cursor: linkTo ? 'pointer' : 'default',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': linkTo ? {
                    transform: 'translateY(-2px)',
                    boxShadow: 4,
                } : {},
                height: '100%',
            }}
            onClick={handleClick}
        >
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            {title}
                        </Typography>
                        <Typography variant="h4" fontWeight="bold">
                            {value}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: `${color}20`,
                            borderRadius: '50%',
                            p: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box sx={{ color, fontSize: 32, display: 'flex' }}>
                            {icon}
                        </Box>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default KpiCard;
